// import { Tabs, Tab, Box, useTheme } from "@mui/material";
// import { NavLink, Outlet, useLocation } from "react-router-dom";

// export default function Analytics() {
//   const theme = useTheme();

//   const tabs = [
//     { label: "Product Performance", path: "product-performance" },
//     { label: "Mood and Effect Trend", path: "mood-trend" },
//     { label: "Conversation Analytics", path: "conversation-analytics" },
//     { label: "Sales and Conversion Insight", path: "sales-insight" },
//     { label: "Engagement Timing", path: "engagement-timing" },
//   ];

//   const location = useLocation();
//   const activeTab = tabs.findIndex(tab =>
//     location.pathname.includes(tab.path)
//   );

//   return (
//     <Box sx={{ width: "100%" }}>

//       {/* Tabs Navbar */}
//       <Box
//         sx={{
//           borderBottom: `1px solid ${theme.palette.divider}`,
//           position: "sticky",
//           top: 0,
//           backgroundColor: theme.palette.background.paper,
//           zIndex: 10,
//         }}
//       >
//         <Tabs
//           value={activeTab === -1 ? 0 : activeTab}
//           variant="scrollable"
//           scrollButtons={false} // 👈 correct fix to hide arrows
//           aria-label="Analytics Tabs"
//           sx={{
//             minHeight: "44px",

//             "& .MuiTabs-indicator": {
//               height: "3px",
//               borderRadius: "2px",
//               backgroundColor: theme.palette.primary.main,
//               transition: "all 0.25s ease",
//             },

//             "& .MuiTab-root": {
//               textTransform: "none",
//               fontSize: "13px", // 👈 smaller font to fit on screen
//               fontWeight: 500,
//               padding: "6px 10px", // 👈 tightened padding
//               minHeight: "44px",
//               color: theme.palette.text.secondary,

//               "&:hover": {
//                 color: theme.palette.primary.main,
//                 opacity: 0.8,
//               }
//             },

//             "& .Mui-selected": {
//               color: theme.palette.primary.main + " !important",
//               fontWeight: 600,
//               fontSize: "14px", // 👈 slight highlight when active
//             },
//           }}
//         >
//           {tabs.map(tab => (
//             <Tab
//               key={tab.path}
//               label={tab.label}
//               component={NavLink}
//               to={tab.path}
//               sx={{
//                 transition: "0.25s ease",
//                 minWidth: "auto" // 👈 allows tabs to shrink more
//               }}
//             />
//           ))}
//         </Tabs>
//       </Box>

//       {/* Nested Page Content */}
//       <Box sx={{ padding: "24px" }}>
//         <Outlet />
//       </Box>
//     </Box>
//   );
// }
// import { Tabs, Tab, Box, useTheme } from "@mui/material";
// import { NavLink, Outlet, useLocation } from "react-router-dom";
// import DateFilter from "../../../components/ClientDashboard/analytics-components/DateFilter";


// export default function Analytics() {
//   const theme = useTheme();

//   const tabs = [
//     { label: "Product Performance", path: "product-performance" },
//     { label: "Mood and Effect Trend", path: "mood-trend" },
//     { label: "Conversation Analytics", path: "conversation-analytics" },
//     { label: "Sales and Conversion Insight", path: "sales-insight" },
//     { label: "Engagement Timing", path: "engagement-timing" },
//   ];

//   const location = useLocation();
//   const activeTab = tabs.findIndex(tab => location.pathname.includes(tab.path));

//   return (
//     <Box sx={{ width: "100%" }}>

//       {/* Tab Bar */}
//       <Box
//         sx={{
//           borderBottom: `1px solid ${theme.palette.divider}`,
//           position: "sticky",
//           top: 0,
//           backgroundColor: theme.palette.background.paper,
//           zIndex: 50,
//         }}
//       >
//         <Tabs
//           value={activeTab === -1 ? 0 : activeTab}
//           variant="scrollable"
//           scrollButtons={false}
//           aria-label="Analytics Tabs"
//           sx={{
//             minHeight: "40px",

//             "& .MuiTabs-indicator": {
//               height: "3px",
//               borderRadius: "2px",
//               backgroundColor: theme.palette.primary.main,
//             },

//             "& .MuiTab-root": {
//               textTransform: "none",
//               fontSize: "13px",
//               padding: "4px 8px",
//               minHeight: "40px",
//               minWidth: "auto",
//               color: theme.palette.text.secondary,

//               "&:hover": {
//                 color: theme.palette.primary.main,
//               },
//             },

//             "& .Mui-selected": {
//               color: theme.palette.primary.main,
//               fontWeight: 600,
//               fontSize: "14px",
//             },
//           }}
//         >
//           {tabs.map(tab => (
//             <Tab
//               key={tab.path}
//               label={tab.label}
//               component={NavLink}
//               to={tab.path}
//             />
//           ))}
//         </Tabs>
//       </Box>

//       {/* Page Content */}
//       <Box sx={{ padding: "20px", mt: 1 }}>
//         <Outlet />
//       </Box>
//     </Box>
//   );
// }


// import { Tabs, Tab, Box, useTheme } from "@mui/material";
// import { NavLink, Outlet, useLocation } from "react-router-dom";
// import { useState } from "react";
// import DateFilter from "../../../components/ClientDashboard/analytics-components/DateFilter";

// export default function Analytics() {
//   const theme = useTheme();
//   const location = useLocation();
//   const [dateFilterValue, setDateFilterValue] = useState("This month");

//   const tabs = [
//     { label: "Product Performance", path: "product-performance" },
//     { label: "Mood and Effect Trend", path: "mood-trend" },
//     { label: "Conversation Analytics", path: "conversation-analytics" },
//     { label: "Sales and Conversion Insight", path: "sales-insight" },
//     { label: "Engagement Timing", path: "engagement-timing" },
//   ];

//   const activeTab = tabs.findIndex(tab => location.pathname.includes(tab.path));

//   return (
//     <Box sx={{ width: "100%" }}>
      
//       {/* ---- TOP TAB BAR ---- */}
//       <Box
//         sx={{
//           borderBottom: `1px solid ${theme.palette.divider}`,
//           position: "sticky",
//           top: 0,
//           backgroundColor: theme.palette.background.paper,
//           zIndex: 50,
//           padding: "6px 10px",
//         }}
//       >
//         <Tabs
//           value={activeTab === -1 ? 0 : activeTab}
//           variant="scrollable"
//           scrollButtons={false}
//           aria-label="Analytics Tabs"
          
//           sx={{
//             minHeight: "40px",

//             "& .MuiTabs-indicator": {
//               height: "3px",
//               borderRadius: "2px",
//               backgroundColor: theme.palette.primary.main,
//             },

//             "& .MuiTab-root": {
//               textTransform: "none",
//               fontSize: "13px",
//               padding: "4px 8px",
//               minHeight: "40px",
//               minWidth: "auto",
//               color: theme.palette.text.secondary,

//               "&:hover": {
//                 color: theme.palette.primary.main,
//               },
//             },

//             "& .Mui-selected": {
//               color: theme.palette.primary.main,
//               fontWeight: 600,
//               fontSize: "14px",
//             },
//           }}
//         >
//           {tabs.map(tab => (
//             <Tab key={tab.path} label={tab.label} component={NavLink} to={tab.path} />
//           ))}
//         </Tabs>
//       </Box>

//       {/* ---- DATE FILTER (below tabs) ---- */}
//       <Box sx={{ px: 2, pt: 2 }}>
//         <DateFilter onChange={(value) => setDateFilterValue(value)} />
//       </Box>

//       {/* ---- PAGE CONTENT ---- */}
//       <Box sx={{ padding: "20px", pt: 1 }}>
//         <Outlet context={{ dateFilterValue }} />
//       </Box>
//     </Box>
//   );
// }



// import { Tabs, Tab, Box, useTheme } from "@mui/material";
// import { NavLink, Outlet, useLocation } from "react-router-dom";
// import { useState } from "react";
// import DateFilter from "../../../components/ClientDashboard/analytics-components/DateFilter";

// export default function Analytics() {
//   const theme = useTheme();
//   const location = useLocation();
//   const [dateFilterValue, setDateFilterValue] = useState("This month");

//   const tabs = [
//     { label: "Product Performance", path: "product-performance"},
//     { label: "Mood and Effect Trend", path: "mood-trend" },
//     { label: "Conversation Analytics", path: "conversation-analytics" },
//     { label: "Sales and Conversion Insight", path: "sales-insight" },
//     { label: "Engagement Timing", path: "engagement-timing" },
//   ];

//   const activeTab = tabs.findIndex(tab => location.pathname.includes(tab.path));

//   return (
//     <Box sx={{ width: "100%" }}>
      
//       {/* ---- TOP TAB BAR ---- */}
//       <Box
//         sx={{
//           borderBottom: `1px solid ${theme.palette.divider}`,
//           position: "sticky",
//           top: 0,
//           backgroundColor: theme.palette.background.paper,
//           zIndex: 50,
//           padding: "6px 10px",
//         }}
//       >
//         <Tabs
//           value={activeTab === -1 ? 0 : activeTab}
//           variant="scrollable"
//           scrollButtons={false}
//           aria-label="Analytics Tabs"
//           sx={{
//             minHeight: "40px",
//             "& .MuiTabs-indicator": {
//               height: "3px",
//               borderRadius: "2px",
//               backgroundColor: theme.palette.primary.main,
//             },
//             "& .MuiTab-root": {
//               textTransform: "none",
//               fontSize: "13px",
//               padding: "4px 8px",
//               minHeight: "40px",
//               minWidth: "auto",
//               color: theme.palette.text.secondary,
//               "&:hover": {
//                 color: theme.palette.primary.main,
//               },
//             },
//             "& .Mui-selected": {
//               color: theme.palette.primary.main,
//               fontWeight: 600,
//               fontSize: "14px",
//             },
//           }}
//         >
//           {tabs.map(tab => (
//             <Tab key={tab.path} label={tab.label} component={NavLink} to={tab.path} />
//           ))}
//         </Tabs>
//       </Box>

//       {/* ---- DATE FILTER ---- */}
//       <Box sx={{ px: 2, pt: 2 }}>
//         <DateFilter onChange={(value) => setDateFilterValue(value)} />
//       </Box>

//       {/* ---- PAGE CONTENT (fixed spacing) ---- */}
//       <Box sx={{ p: 3, pt: 0 }}>
//         <Outlet context={{ dateFilterValue }} />
//       </Box>
//     </Box>
//   );
// }



// #palak
// import { Tabs, Tab, Box, useTheme } from "@mui/material";
// import { NavLink, Outlet, useLocation } from "react-router-dom";
// import { useState } from "react";
// import DateFilter from "../../../components/ClientDashboard/analytics-components/DateFilter";

// export default function Analytics() {
//   const theme = useTheme();
//   const location = useLocation();
//   const [dateFilterValue, setDateFilterValue] = useState("This month");

//   const tabs = [
//     { label: "Product Performance", path: "product-performance"},
//     { label: "Mood and Effect Trend", path: "mood-trend" },
//     { label: "Conversation Analytics", path: "conversation-analytics" },
//     { label: "Sales and Conversion Insight", path: "sales-insight" },
//     { label: "Engagement Timing", path: "engagement-timing" },
//   ];

//   const activeTab = tabs.findIndex(tab => location.pathname.includes(tab.path));

//   return (
//     <Box sx={{ width: "100%" }}>
      
//       {/* ---- TOP TAB BAR ---- */}
//       <Box
//         sx={{
//           borderBottom: `1px solid ${theme.palette.divider}`,
//           position: "sticky",
//           top: 0,
//           backgroundColor: theme.palette.background.paper,
//           zIndex: 50,
//           padding: "6px 10px",
//         }}
//       >
//         <Tabs
//           value={activeTab === -1 ? 0 : activeTab}
//           variant="scrollable"
//           scrollButtons={false}
//           aria-label="Analytics Tabs"
//           sx={{
//             minHeight: "40px",
//             "& .MuiTabs-indicator": {
//               height: "3px",
//               borderRadius: "2px",
//               backgroundColor: theme.palette.primary.main,
//             },
//             "& .MuiTab-root": {
//               textTransform: "none",
//               fontSize: "13px",
//               padding: "4px 8px",
//               minHeight: "40px",
//               minWidth: "auto",
//               color: theme.palette.text.secondary,
//               "&:hover": { color: theme.palette.primary.main },
//             },
//             "& .Mui-selected": {
//               color: theme.palette.primary.main,
//               fontWeight: 600,
//               fontSize: "14px",
//             },
//           }}
//         >
//           {tabs.map(tab => (
//             <Tab key={tab.path} label={tab.label} component={NavLink} to={tab.path} />
//           ))}
//         </Tabs>
//       </Box>

//       {/* ---- DATE FILTER ---- */}
//       <Box sx={{ px: 2, pt: 2, mb:0}}>
//         <DateFilter onChange={(value) => setDateFilterValue(value)} />
//       </Box>

//       {/* ---- PAGE CONTENT (Spacing Fixed) ---- */}
//       <Box sx={{ p: 3, pt: 0 }}>
//         <Outlet context={{ dateFilterValue }} />
//       </Box>
//     </Box>
//   );
// }



// import { Tabs, Tab, Box, useTheme } from "@mui/material";
// import { NavLink, Outlet, useLocation } from "react-router-dom";
// import { useState } from "react";
// import DateFilter from "../../../components/ClientDashboard/analytics-components/DateFilter";

// export default function Analytics() {
//   const theme = useTheme();
//   const location = useLocation();
//   const [dateFilterValue, setDateFilterValue] = useState("This month");

//   const tabs = [
//     { label: "Product Performance", path: "product-performance" },
//     { label: "Mood and Effect Trend", path: "mood-trend" },
//     { label: "Conversation Analytics", path: "conversation-analytics" },
//     { label: "Sales and Conversion Insight", path: "sales-insight" },
//     { label: "Engagement Timing", path: "engagement-timing" },
//   ];

//   const activeTab = tabs.findIndex(tab => location.pathname.includes(tab.path));

//   return (
//     <Box sx={{ width: "100%" }}>

//       {/* ---- TOP BAR (Tabs + Filter) ---- */}
//       <Box
//         sx={{
//           borderBottom: `1px solid ${theme.palette.divider}`,
//           position: "sticky",
//           top: 0,
//           backgroundColor: theme.palette.background.paper,
//           zIndex: 50,
//           display: "flex",
//           alignItems: "center",
//           justifyContent: "space-between",
//           p: "6px 10px",
//           gap: 2
//         }}
//       >
//         {/* LEFT: Tabs */}
//         <Tabs
//           value={activeTab === -1 ? 0 : activeTab}
//           variant="scrollable"
//           scrollButtons={false}
//           aria-label="Analytics Tabs"
//           sx={{
//             minHeight: "40px",
//             "& .MuiTabs-indicator": {
//               height: "3px",
//               borderRadius: "2px",
//               backgroundColor: theme.palette.primary.main,
//             },
//             "& .MuiTab-root": {
//               textTransform: "none",
//               fontSize: "13px",
//               minHeight: "40px",
//               minWidth: "auto",
//               padding: "4px 8px",
//               color: theme.palette.text.secondary,
//               "&:hover": { color: theme.palette.primary.main },
//             },
//             "& .Mui-selected": {
//               color: theme.palette.primary.main,
//               fontWeight: 600,
//               fontSize: "14px",
//             },
//           }}
//         >
//           {tabs.map(tab => (
//             <Tab key={tab.path} label={tab.label} component={NavLink} to={tab.path} />
//           ))}
//         </Tabs>

//         {/* RIGHT: Date Filter (Now aligned, no gap) */}
//         <Box>
//           <DateFilter onChange={(value) => setDateFilterValue(value)} />
//         </Box>
//       </Box>

//       {/* ---- PAGE CONTENT ---- */}
//       <Box sx={{ p: 3 }}>
//         <Outlet context={{ dateFilterValue }} />
//       </Box>

//     </Box>
//   );
// }










// import { Tabs, Tab, Box, useTheme, Paper } from "@mui/material";
// import { NavLink, Outlet, useLocation } from "react-router-dom";
// import { useState } from "react";
// import DateFilter from "../../../components/ClientDashboard/analytics-components/DateFilter";

// export default function Analytics() {
//   const theme = useTheme();
//   const location = useLocation();
//   const [dateFilterValue, setDateFilterValue] = useState("This month");

//   const tabs = [
//     { label: "Product Performance", path: "product-performance" },
//     { label: "Mood and Effect Trend", path: "mood-trend" },
//     { label: "Conversation Analytics", path: "conversation-analytics" },
//     { label: "Sales and Conversion Insight", path: "sales-insight" },
//     { label: "Engagement Timing", path: "engagement-timing" },
//   ];

//   const activeTab = tabs.findIndex((tab) => location.pathname.includes(tab.path));

//   return (
//     <Box sx={{ width: "100%" }}>

//       {/* ---- Top Control Bar ---- */}
//       <Paper
//         elevation={0}
//         sx={{
//           borderBottom: `1px solid ${theme.palette.divider}`,
//           display: "flex",
//           alignItems: "center",
//           justifyContent: "space-between",
//           px: 3,
//           py: 1.5,
//           borderRadius: 0,
//           position: "sticky",
//           top: 0,
//           backgroundColor: theme.palette.background.paper,
//           zIndex: 20,
//         }}
//       >
//         {/* Tabs */}
//         <Tabs
//           value={activeTab === -1 ? 0 : activeTab}
//           variant="scrollable"
//           scrollButtons={false}
//           sx={{
//             minHeight: "44px",
//             "& .MuiTabs-indicator": {
//               height: "3px",
//               backgroundColor: theme.palette.primary.main,
//               borderRadius: "3px",
//             },
//             "& .MuiTab-root": {
//               fontSize: "14px",
//               textTransform: "none",
//               fontWeight: 500,
//               color: theme.palette.text.secondary,
//               minHeight: "44px",
//               padding: "6px 10px",
//             },
//             "& .Mui-selected": {
//               color: theme.palette.primary.main,
//               fontWeight: 600,
//             },
//           }}
//         >
//           {tabs.map((tab) => (
//             <Tab key={tab.path} label={tab.label} component={NavLink} to={tab.path} />
//           ))}
//         </Tabs>

//         {/* Date Filter */}
//         <Box>
//           <DateFilter onChange={setDateFilterValue} />
//         </Box>
//       </Paper>

//       {/* ---- Page content ---- */}
//       <Box sx={{ px: 3, py: 3 }}>
//         <Outlet context={{ dateFilterValue }} />
//       </Box>
//     </Box>
//   );
// }







import { Tabs, Tab, Box, useTheme } from "@mui/material";
import { NavLink, Outlet, useLocation } from "react-router-dom";
import { useState } from "react";
import DateFilter from "../../../components/ClientDashboard/analytics-components/DateFilter";

export default function Analytics() {
  const theme = useTheme();
  const location = useLocation();
  const [dateFilterValue, setDateFilterValue] = useState("Last 3 months");

  const tabs = [
    { label: "Product Performance", path: "product-performance" },
    { label: "Mood and Effect Trend", path: "mood-trend" },
    { label: "Conversation Analytics", path: "conversation-analytics" },
    { label: "Sales and Conversion Insight", path: "sales-insight" },
    { label: "Engagement Timing", path: "engagement-timing" },
  ];

  // Determine if we're on a detail page (hide date filter on detail pages)
  const isDetailPage = location.pathname.includes("/details") || location.pathname.includes("peak-interaction-details");

  // Determine active tab based on pathname
  // Check for detail pages first, then main tabs
  let activeTab = -1;

  if (location.pathname.includes("drop-off-keyword-insights") ||
      location.pathname.includes("most-repeated-user-queries") ||
      location.pathname.includes("user-acquisition-retention-trends")) {
    activeTab = 2; // Conversation Analytics
  } else if (location.pathname.includes("top-products") ||
             location.pathname.includes("high-clicks") ||
             location.pathname.includes("most-recommended")) {
    activeTab = 0; // Product Performance
  } else if (location.pathname.includes("mood-trend")) {
    activeTab = 1; // Mood and Effect Trend
  } else if (location.pathname.includes("product-funnel") ||
             location.pathname.includes("revenue-driven")) {
    activeTab = 3; // Sales and Conversion Insight
  } else if (location.pathname.includes("engagement-timing")) {
    activeTab = 4; // Engagement Timing
  } else {
    // Fallback to original logic for main tabs
    activeTab = tabs.findIndex(tab => location.pathname.includes(tab.path));
  }

  if (activeTab === -1) activeTab = 0;

  return (
    <Box sx={{ width: "100%" }}>

      {/* ---- TOP TAB BAR ---- */}
      <Box
        sx={{
          borderBottom: `1px solid ${theme.palette.divider}`,
          position: "sticky",
          top: 0,
          backgroundColor: theme.palette.background.paper,
          zIndex: 50,
          padding: "4px 10px", // reduced padding
        }}
      >
        <Tabs
          value={activeTab === -1 ? 0 : activeTab}
          variant="scrollable"
          scrollButtons={false}
          aria-label="Analytics Tabs"
          sx={{
            minHeight: "38px",
            "& .MuiTabs-indicator": {
              height: "3px",
              borderRadius: "2px",
              backgroundColor: theme.palette.primary.main,
            },
            "& .MuiTab-root": {
              textTransform: "none",
              fontSize: "13px",
              padding: "4px 8px",
              minHeight: "38px",
              minWidth: "auto",
              color: theme.palette.text.secondary,
              "&:hover": { color: theme.palette.primary.main },
            },
            "& .Mui-selected": {
              color: theme.palette.primary.main,
              fontWeight: 600,
              fontSize: "14px",
            },
          }}
        >
          {tabs.map(tab => (
            <Tab key={tab.path} label={tab.label} component={NavLink} to={tab.path} />
          ))}
        </Tabs>
      </Box>

      {/* ---- DATE FILTER (Hidden on detail pages) ---- */}
      {!isDetailPage && (
        <Box sx={{ px: 2, pt: 0.5, mb: 0 }}>
          <DateFilter onChange={(value) => setDateFilterValue(value)} />
        </Box>
      )}

      {/* ---- PAGE CONTENT (Reduced gap) ---- */}
      <Box sx={{ px: 2, pt: 0.5, pb: 3 }}>
        <Outlet context={{ dateFilterValue }} />
      </Box>
    </Box>
  );
}
